import request from '@@/utils/request'

export async function getCaptcha() {
  return request('/captcha', {
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

export async function checkCaptcha(data) {
  return request('/captcha', {
    method: 'post',
    headers: {
      isToken: false
    },
    data: data
  })
}
